import * as PIXI from 'pixi.js';
import gsap from 'gsap';
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import LocaleManager from '../components/LocaleManager';
import { GameConfig } from '../utils/GameConfig';
import Tools from '../utils/Tools';
import config from "config";
import tools from 'tools';

export default class DailyChallenge extends PIXI.Container {
    constructor() {
        super();

        tools.autobind(this);

        this._heightView = GameManager.heightView;
        
        // The data for the daily challenge
        this.dailyChallengeData = null;
        // Last time player finish the 3 daily challenges, default is the first time player play the game
        this.lastFinishDailyTime = null;
        // Current difficulty of the challenge
        this.currentDifficulty = null;
        // Current index of the challenge in today
        this.currentDailyIndex = null;
        // Current ongoing challenge
        this.currentChallenge = null;
        // Current progress count of the challenge
        this.currentProgress = null;
        // Array of the challenge finished
        this.challengeFinished = null;
        // Array of the friends been already surpassed
        this.friendsSurpassed = null;

        // The mission name text
        this.missionNameText = null;
        // The max length of the mission detail
        this.missionDetailTextLength = 57;
        // The mission detail text
        this.missionDetailText = null;
        // The mission reward text
        this.missionRewardText = null;
        // The mission count text
        this.missionCountText = null;

        // Arc background
        this.arcBackground = null;
        // Arc progress
        this.arcProgress = null;

        // Image background of the friend
        this.friendBg = null;

        // Image of the friend for the 4th mission
        this.friendImg = null;

        // Number of coins rewarded
        this.missionRewardCoins = null;

        // Is the level started
        this.isLevelStarted = false;

        // Is the daily challenge loaded
        this.isChallengeLoaded = false;

        // The friend to be charged in the surpass challenge
        this.friendSurpass = null;

        // Count to finish the challenge
        this.finishChallengeCount = null;
        this.currentChallengeCount = 0;

        this._coefY = .7;

        this.initDailyChallenge = this.initDailyChallenge.bind(this);
        this._onBounce = this._onBounce.bind(this);
        this._onDestoryPlatform = this._onDestoryPlatform.bind(this);
        this._onScore = this._onScore.bind(this);
        this._onUseBooster = this._onUseBooster.bind(this);
        // this._onReachScore = this._onReachScore.bind(this);

        this.contextChallengerContainer = new PIXI.Container();
        this.contextChallengerContainer.visible = false;
        this.addChild(this.contextChallengerContainer);

        this.challengerContainer = new PIXI.Container();
        this.challengerContainer.visible = false;
        this.addChild(this.challengerContainer);

        this.initDailyChallenge();
    }


    set default(val) {

        this._default = val;
        this.contextChallengerContainer.visible = !val;
        this.challengerContainer.visible = val;

        if (!val) {

            this.contextChallengerContainer.addChild(this.background);
            this.contextChallengerContainer.addChild(this.missionCountText);
            this.contextChallengerContainer.addChild(this.missionDetailText)
            this.contextChallengerContainer.addChild(this.coinIcon);
            this.contextChallengerContainer.addChild(this.missionRewardText);
            this.contextChallengerContainer.addChild(this.missionNameText);
            this.contextChallengerContainer.addChild(this.sphere);
            this.contextChallengerContainer.addChild(this.checkMarkBackground);
            this.contextChallengerContainer.addChild(this.checkMark);

            this._createContextChallenger();


        } else {
            this.challengerContainer.addChild(this.background);
            this.challengerContainer.addChild(this.missionDetailText);
            this.challengerContainer.addChild(this.coinIcon);
            this.challengerContainer.addChild(this.missionRewardText);
            this.challengerContainer.addChild(this.missionNameText);
            this.challengerContainer.addChild(this.sphere);
            this.challengerContainer.addChild(this.arcBackground);
            this.challengerContainer.addChild(this.missionCountText);
            this.challengerContainer.addChild(this.checkMarkBackground);
            this.challengerContainer.addChild(this.checkMark);

        }

    }


    get default() {
        return this._default;
    }


    set opponent(val) {
        this._opponent = val;
    }


    get opponent() {
        return this._opponent;
    }

    set realScore(val) {
        this._realScore = val;
    }


    get realScore() {
        return this._realScore;
    }


    notifyLevelStart() {
        this.isLevelStarted = true;

        gsap.to(this.scale, { duration: .3, x: 1.2, y: 1.2 });

    }

    initDailyChallenge() {
        // Init graphics of the daily challenge

        // Adjust the container position
        this.position.set(-200, window.innerHeight * this._coefY);

        // Initialize daily challenge background
        const backgroundTexture = AssetsManager.texturesPixi.challengeBackground;
        this.background = new PIXI.Sprite(backgroundTexture);
        this.background.position.set(-10, 2);
        this.background.scale.set(0.2);
        this.background.anchor.set(0, 0.5);
        this.challengerContainer.addChild(this.background);

        // Initialize the challenge sphere
        const sphereTexture = AssetsManager.texturesPixi.challengeSphere;
        this.sphere = new PIXI.Sprite(sphereTexture);
        this.sphere.position.set(90, 0);
        this.sphere.scale.set(0.25);
        this.sphere.anchor.set(0.5);
        this.challengerContainer.addChild(this.sphere);


        // Text style
        const dailyChallengeStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 20,
            fill: '#ffffff',
        });

        // Initialize the mission name
        this.missionNameText = new PIXI.Text('MISSION 1', dailyChallengeStyle);
        this.missionNameText.scale.set(0.5);
        this.missionNameText.anchor.set(0.5);
        this.missionNameText.position.set(35, -30);
        this.challengerContainer.addChild(this.missionNameText);


        // Initialize the mission reward
        this.missionRewardText = new PIXI.Text('100', dailyChallengeStyle);
        this.missionRewardText.scale.set(0.5);
        this.missionRewardText.anchor.set(0.5);
        this.missionRewardText.position.set(37, 30);
        this.challengerContainer.addChild(this.missionRewardText);


        const coinIconTexture = AssetsManager.texturesPixi.coinsGold;
        this.coinIcon = new PIXI.Sprite(coinIconTexture);
        this.coinIcon.position.set(15, 30);
        this.coinIcon.scale.set(0.07);
        this.coinIcon.anchor.set(0.5);
        this.challengerContainer.addChild(this.coinIcon);


        // Initialize the mission detail
        this.missionDetailText = new PIXI.Text('BOUNCE\n100 TIMES', dailyChallengeStyle);
        this.missionDetailText.scale.set(0.5);
        this.missionDetailText.anchor.set(0, 0.5);
        this.missionDetailText.position.set(5, 0);
        this.challengerContainer.addChild(this.missionDetailText);


        // Text type
        const missionCountStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 20,
            fill: '#0068fc ',
        });

        // Initialize the mission count
        this.missionCountText = new PIXI.Text('100', missionCountStyle);
        this.missionCountText.scale.set(0.6);
        this.missionCountText.anchor.set(0.5);
        this.missionCountText.position.set(90, 0);
        this.challengerContainer.addChild(this.missionCountText);


        // Initialize the mission progress
        this.arcBackground = new PIXI.Graphics();
        this.arcBackground.lineStyle(9, 0x474747, 1);
        this.arcBackground.drawCircle(0, 0, 18);
        this.arcBackground.position.set(90, 0);
        this.challengerContainer.addChild(this.arcBackground);


        this._setupProgressArc(0.7);

        // Initialize the check mark
        const checkMarkTexture = AssetsManager.texturesPixi.challengeCheckMark;
        this.checkMark = new PIXI.Sprite(checkMarkTexture);
        this.checkMark.anchor.set(0.5);
        this.checkMark.scale.set(0.3);
        this.checkMark.position.set(90, 0);
        this.checkMark.visible = false;
        this.challengerContainer.addChild(this.checkMark);


        // Initialize the green circle
        this.checkMarkBackground = new PIXI.Graphics();
        this.checkMarkBackground.lineStyle(9, 0x76e30c, 1);
        this.checkMarkBackground.drawCircle(0, 0, 18);
        this.checkMarkBackground.position.set(90, 0);
        this.checkMarkBackground.visible = false;
        this.challengerContainer.addChild(this.checkMarkBackground);


    }

    updateDailyChallenge(dailyChallengeData) {

        // console.log(">> updateDailyChallenge", dailyChallengeData);

        // Load the data into the class
        this.dailyChallengeData = dailyChallengeData;
        this.lastFinishDailyTime = dailyChallengeData.lastFinishDailyTime;
        this.currentDifficulty = dailyChallengeData.currentDifficulty;
        this.currentDailyIndex = dailyChallengeData.currentDailyIndex;
        this.currentChallenge = dailyChallengeData.currentChallenge <= 3 ? dailyChallengeData.currentChallenge : 0;
        this.currentProgress = dailyChallengeData.currentProgress;
        this.challengeFinished = dailyChallengeData.challengeFinished;
        this.friendsSurpassed = dailyChallengeData.friendsSurpassed;

        // console.log("this.dailyChallengeData:", this.dailyChallengeData);

        console.log("this.isChallengeLoaded:",this.isChallengeLoaded)

        if (!this.isChallengeLoaded) {
            // If no challenge is loaded
            // var timeNow = Date.now();
            // if (timeNow - this.lastFinishDailyTime > 24 * 60 * 60 * 1000) {
            //     // If last finish daily challenge time is 1 day before, reset the 3 challenges
            //     console.log("Last play time 1 day ago, reset 3 mission");

            //     // Reset some parameters
            //     // this.dailyChallengeData.lastFinishDailyTime = Date.now();
            //     this.dailyChallengeData.currentDailyIndex = 0;
            //     this.dailyChallengeData.currentProgress = 0;

            //     // Remove the finished challenge from the available challenge list
            //     var availableChallenges = [0, 1, 2, 3];
            //     for (let index = 0; index < this.challengeFinished.length; index++) {
            //         const challengeFinished = this.challengeFinished[index];
            //         availableChallenges.splice(availableChallenges.indexOf(challengeFinished), 1);
            //     }

            //     //console.log("availableChallenges", availableChallenges);

            //     if (availableChallenges.length === 0) {
            //         // No available challenge, raise difficulty
            //         this.dailyChallengeData.currentDifficulty += 1;
            //         this.dailyChallengeData.challengeFinished = [];
            //         availableChallenges = [0, 1, 2, 3];
            //     }
            //     else {
            //         this.dailyChallengeData.currentDifficulty = this.currentDifficulty;
            //         this.dailyChallengeData.challengeFinished = this.challengeFinished;
            //     }

            //     if (this.currentChallenge >= 3) {
            //         this.currentChallenge = 0;
            //     } else {
            //         this.currentChallenge++;
            //     }

            //     this.dailyChallengeData.currentChallenge = this.currentChallenge;

            //     GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;

            //     return;
            // }
            // else {

                this._createChallenge();
                this.isChallengeLoaded = true;

            // }
        }
        else {
            // If a challenge is loaded
            const percent = this.currentProgress / this.finishChallengeCount;
            this._setupProgressArc(percent);
        }
    }


    restart() {

        this.isLevelStarted = false;

        this.scale.set(1.5);

        // Adjust the container position
        this.position.set(-200, window.innerHeight * this._coefY);
        this.isChallengeLoaded = false;

        // If it is not the last daily challenge, update the daily challenge with the progress = 0
        //console.log("this.currentDailyIndex", this.currentDailyIndex);
        console.log("this.dailyChallengeData:", this.dailyChallengeData);
        // if (this.currentDailyIndex <= 3) {
        GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;
        // }
    }

    _createChallenge() {


        // Play the create challenge animation
        this.position.y = window.innerHeight * this._coefY;
        gsap.fromTo(this.position, { x: -200 }, { x: 0, duration: 0.5 });

        // Set up the reward
        this.missionRewardCoins = 200 + this.currentDifficulty * 100

        if (!this.default) {
            return;
        }

        // Set up the mission name
        this.missionNameText.text = LocaleManager.words.mission + " " + (this.dailyChallengeData.missionIndex + 1);

        // Set up the challenge type according to the difficulty
        var percent = 0;
        switch (this.currentChallenge) {
            case 0:
                // Add event listeners for the daily challenge event
                GameManager.EVENT_DISPATCHER.addEventListener('bounce', this._onBounce);

                // Bounce challenge
                this.finishChallengeCount = (this.currentDifficulty + 1) * 100;
                if (GameManager.GAME.isDebug) {
                    this.finishChallengeCount = (this.currentDifficulty + 1) * 5;
                }
                //percent = this.currentProgress / this.finishChallengeCount;
                this._setupProgressArc(percent);
                this.missionDetailText.text = LocaleManager.words.bounce + "\n" + (this.finishChallengeCount) + " " + LocaleManager.words.times;
                if (this.missionDetailText.width > this.missionDetailTextLength) {
                    this.missionDetailText.width = this.missionDetailTextLength;
                    this.missionDetailText.scale.y = this.missionDetailText.scale.x;
                }
                this.missionRewardText.text = this.missionRewardCoins;
                break;
            case 1:
                // Add event listeners for the daily challenge event
                GameManager.EVENT_DISPATCHER.addEventListener('destoryPlatform', this._onDestoryPlatform);

                // Destory challenge
                this.finishChallengeCount = (this.currentDifficulty + 1) * 100;
                if (GameManager.GAME.isDebug) {
                    this.finishChallengeCount = (this.currentDifficulty + 1) * 5;
                }
                //percent = this.currentProgress / this.finishChallengeCount;
                this._setupProgressArc(percent);
                this.missionDetailText.text = LocaleManager.words.pass + " " + (this.finishChallengeCount) + "\n" + LocaleManager.words.platforms;
                if (this.missionDetailText.width > this.missionDetailTextLength) {
                    this.missionDetailText.width = this.missionDetailTextLength;
                    this.missionDetailText.scale.y = this.missionDetailText.scale.x;
                }
                this.missionRewardText.text = this.missionRewardCoins;
                break;
            case 2:
                // Add event listeners for the daily challenge event
                GameManager.EVENT_DISPATCHER.addEventListener('score', this._onScore);

                // Score challenge
                this.finishChallengeCount = (this.currentDifficulty + 1) * 500;
                if (GameManager.GAME.isDebug) {
                    this.finishChallengeCount = (this.currentDifficulty + 1) * 30;
                }
                //percent = this.currentProgress / this.finishChallengeCount;
                this._setupProgressArc(percent);
                this.missionDetailText.text = LocaleManager.words.scoreDaily + "\n" + (this.finishChallengeCount) + " " + LocaleManager.words.points;
                if (this.missionDetailText.width > this.missionDetailTextLength) {
                    this.missionDetailText.width = this.missionDetailTextLength;
                    this.missionDetailText.scale.y = this.missionDetailText.scale.x;
                }
                this.missionRewardText.text = this.missionRewardCoins;
                break;
            case 3:
                // Add event listeners for the daily challenge event
                GameManager.EVENT_DISPATCHER.addEventListener('useBooster', this._onUseBooster);

                // Booster challenge
                this.finishChallengeCount = this.currentDifficulty + 3;
                if (GameManager.GAME.isDebug) {
                    this.finishChallengeCount = this.currentDifficulty + 1;
                }
                //percent = this.currentProgress / this.finishChallengeCount;
                this._setupProgressArc(percent);
                this.missionDetailText.text = LocaleManager.words.use + " " + (this.finishChallengeCount) + "\n" + LocaleManager.words.boosters;
                if (this.missionDetailText.width > this.missionDetailTextLength) {
                    this.missionDetailText.width = this.missionDetailTextLength;
                    this.missionDetailText.scale.y = this.missionDetailText.scale.x;
                }
                this.missionRewardText.text = this.missionRewardCoins;
                break;
            // case 4:
            //     // Add event listeners for the daily challenge event
            //     GameManager.EVENT_DISPATCHER.addEventListener('score', this._onReachScore);

            //     // Create the challenger according to the challenger list in config
            //     this._createChallenger();
            //     break;

            default:
                break;
        }

        // Set up the visual components
        this.missionCountText.visible = true;
        this.arcBackground.visible = true;

        this.checkMark.visible = false;
        this.checkMarkBackground.visible = false;

    }

    _finishChallenge() {
        //console.log("_finishChallenge");
        // Give the rewarded coin
        // GameManager.COIN += this.missionRewardCoins;
        this._addCoins(this.missionRewardCoins);


        // Remove the event listeners for the daily challenge event
        switch (this.currentChallenge) {
            case 0:
                GameManager.EVENT_DISPATCHER.removeEventListener('bounce', this._onBounce);
                break;
            case 1:
                GameManager.EVENT_DISPATCHER.removeEventListener('destoryPlatform', this._onDestoryPlatform);
                break;
            case 2:
                GameManager.EVENT_DISPATCHER.removeEventListener('score', this._onScore);
                break;
            case 3:
                GameManager.EVENT_DISPATCHER.removeEventListener('useBooster', this._onUseBooster);
                break;
            // case 4:
            //     GameManager.EVENT_DISPATCHER.removeEventListener('score', this._onReachScore);
            //     break;
            default:
                break;
        }

        // Set up the visual components
        this.checkMark.visible = true;
        this.checkMarkBackground.visible = true;

        this.missionCountText.visible = false;
        this.arcBackground.visible = false;
        this.arcProgress.visible = false;
        if (this.friendBg != null) {
            this.friendBg.visible = false;
        }
        if (this.friendImg != null) {
            this.friendImg.visible = false;
        }

        // Play the finish challenge animation
        gsap.to(this.position, { x: -80, duration: 0.5 });
        gsap.to(this.position, { y: -200, duration: 1, delay: 2 });

        // After the animation is finished
        gsap.delayedCall(3.5, () => {

            this.challengeFinished.push(this.currentChallenge);

            var availableChallenges = [0, 1, 2, 3];

            for (let index = 0; index < this.challengeFinished.length; index++) {
                const challengeFinished = this.challengeFinished[index];
                availableChallenges.splice(availableChallenges.indexOf(challengeFinished), 1);
            }
            console.log("availableChallenges", availableChallenges);

            // If all the available challenges are done, difficulty + 1
            if (availableChallenges.length === 0) {
                this.currentDifficulty += 1;
                this.challengeFinished = [];
                availableChallenges = [0, 1, 2, 3];
            }

            // Randomly choose a challenge from all the available challenges
            // this.currentChallenge = availableChallenges[Tools.randomNum(0, availableChallenges.length - 1)];
            if (this.currentChallenge >= 3) {
                this.currentChallenge = 0;
            } else {
                this.currentChallenge++;
            }
            // }
            this.dailyChallengeData.currentChallenge = this.currentChallenge;

            this.dailyChallengeData.currentProgress = 0;

            this.isChallengeLoaded = false;


            // this.dailyChallengeData.lastFinishDailyTime = Date.now();

            this.currentDailyIndex += 1;
            this.dailyChallengeData.currentDailyIndex = this.currentDailyIndex;
            this.dailyChallengeData.missionIndex += 1;

            this.dailyChallengeData.currentDifficulty = this.currentDifficulty;

            this.dailyChallengeData.challengeFinished = this.challengeFinished;

            // Generate new daily challenge automatically done by set the value of dailyChallengeData
            GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;

            console.log("finish challenge", this.dailyChallengeData);

        });
    }




    _finishContextChallenge() {

        GameManager.EVENT_DISPATCHER.removeEventListener('score', this._onContextReachScore);

        this._addCoins(this.missionRewardCoins);

        // Set up the visual components
        this.checkMark.visible = true;
        this.checkMarkBackground.visible = true;

        this.missionCountText.visible = false;
        this.friendBg.visible = false;
        this.friendImg.visible = false;

        // Play the finish challenge animation
        gsap.to(this.position, { x: -80, duration: 0.5 });
        gsap.to(this.position, { y: -200, duration: 1, delay: 2 });


    }



    _onBounce() {
        if (this.isLevelStarted && this.default) {
            this.currentProgress += 1;
            if (this.currentProgress < this.finishChallengeCount) {
                this.dailyChallengeData.currentProgress = this.currentProgress;
                GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;
            }
            else {
                this._finishChallenge();
            }
        }
    }

    _onDestoryPlatform() {
        if (this.isLevelStarted && this.default) {
            this.currentProgress += 1;
            if (this.currentProgress < this.finishChallengeCount) {
                this.dailyChallengeData.currentProgress = this.currentProgress;
                GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;
            }
            else {
                this._finishChallenge();
            }
        }
    }

    _onScore() {
        if (this.isLevelStarted && this.default) {
            this.currentProgress += 20;
            if (this.currentProgress < this.finishChallengeCount) {
                this.dailyChallengeData.currentProgress = this.currentProgress;
                GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;
            }
            else {
                this._finishChallenge();
            }
        }
    }

    _onUseBooster() {
        if (this.isLevelStarted && this.default) {
            this.currentProgress += 1;
            if (this.currentProgress < this.finishChallengeCount) {
                this.dailyChallengeData.currentProgress = this.currentProgress;
                GameManager.DAILY_CHALLENGE_DATA = this.dailyChallengeData;
            }
            else {
                this._finishChallenge();
            }
        }
    }

    // _onReachScore() {
    //     if (this.isLevelStarted && this.default) {
    //         this.currentProgress = 0;
    //         console.log("Reach Score", GameManager.SCORE, this.finishChallengeCount)
    //         if (GameManager.SCORE >= this.finishChallengeCount) {
    //             this._finishChallenge();
    //         }
    //     }
    // }

    _onContextReachScore() {

        if (this.isLevelStarted) {

            console.log(GameManager.SCORE, ">=", this.opponent.score)
            if (GameManager.SCORE >= this.opponent.score) {
                this._finishContextChallenge();
                if (config.beatenOpponent.indexOf(config.currentContext) == -1) {
                    config.beatenOpponent += config.currentContext + ",";
                }
            }

        }

    }

    _setupProgressArc(percent) {
        //console.log('_setupProgressArc', percent);

        // Show the number
        if (this.currentProgress != null) {
            this.missionCountText.text = this.currentProgress;
        }

        // Clean the last arc
        if (this.arcProgress != null) {
            this.challengerContainer.removeChild(this.arcProgress);
        }

        this.arcProgress = new PIXI.Graphics();
        this.arcProgress.lineStyle(9, 0x1371ff, 1);
        this.arcProgress.arc(0, 0, 18, - 0.5 * Math.PI, 2 * Math.PI * percent - 0.5 * Math.PI);
        this.arcProgress.position.set(90, 0);
        this.arcProgress.visible = true;
        this.challengerContainer.addChild(this.arcProgress);
    }

    // _createChallenger() {

    //     if (!this.default) {
    //         return;
    //     }

    //     //console.log("config.friends", config.friends);
    //     // Get the list of friends and delete the ones who are already surpassed
    //     // var friends = structuredClone(config.friends);
    //     var friends = [];

    //     for (let i = 0; i < config.challengers.length; i++) {
    //         if (config.challengers[i].isFriend) {
    //             friends.push(config.challengers[i]);
    //         }
    //     }
    //     console.log("friends:", friends);

    //     for (let i = 0; i < friends.length; i++) {
    //         const friend = friends[i];
    //         for (let j = 0; j < this.friendsSurpassed.length; j++) {
    //             const friendSurpassed = this.friendsSurpassed[j];

    //             if (friend.id !== "" && friend.name !== "") {
    //                 if (friendSurpassed.includes(friend.id) || friendSurpassed.includes(friend.name)) {
    //                     friends.splice(friends.indexOf(friend), 1);
    //                 }
    //             }
    //         }
    //     }
    //     //console.log("friends", friends);

    //     // If the player has friends, load a random friend, else load the friendsPicto
    //     var friendScore = 500;

    //     if (this.friendBg != null) {
    //         this.challengerContainer.removeChild(this.friendBg);
    //     }

    //     if (this.friendImg != null) {
    //         this.challengerContainer.removeChild(this.friendImg);
    //     }

    //     const friendBgTexture = AssetsManager.texturesPixi.challengerBackground;
    //     this.friendBg = new PIXI.Sprite(friendBgTexture);
    //     this.friendBg.visible = true;
    //     this.challengerContainer.addChild(this.friendBg);
    //     this.friendBg.anchor.set(0.5);
    //     this.friendBg.scale.set(0.35);
    //     this.friendBg.position.set(90, 0);

    //     // Select the friend
    //     const friendsLength = friends.length;
    //     for (let index = 0; index < friendsLength; index++) {
    //         var randomFriendIndex = Tools.randomNum(0, friends.length - 1);
    //         const friend = friends[randomFriendIndex];
    //         friendScore = parseInt(friend.score);
    //         if (GameManager.SCORE > friendScore) {
    //             friends.splice(randomFriendIndex, 1);
    //         }
    //         else {
    //             this.friendSurpass = friend;
    //             break;
    //         }
    //     }
    //     console.log("friend seleted: ", this.friendSurpass);
    //     // var randomFriendIndex = Tools.randomNum(0, friends.length - 1);
    //     // friendScore = parseInt(friends[randomFriendIndex].score);

    //     // If the score of the friend is lower than actual score or no friends
    //     if (friends.length === 0) {
    //         friendScore = 99999;

    //         if (friends.length === 0) {
    //             console.log("no friends found");
    //         }

    //         if (GameManager.SCORE > friendScore) {
    //             console.log("Already surpass the friend's score");
    //         }

    //         const friendsTexture = AssetsManager.texturesPixi.friendsPicto;
    //         this.friendImg = new PIXI.Sprite(friendsTexture);
    //         this.friendImg.visible = true;
    //         this.challengerContainer.addChild(this.friendImg);
    //         this.friendImg.anchor.set(0.5);
    //         this.friendImg.position.set(90, 0);

    //         let sizeTimer = setInterval(() => {
    //             if (this.friendImg.width > 5) {
    //                 this.friendImg.width = 48;
    //                 this.friendImg.scale.y = this.friendImg.scale.x;
    //                 clearInterval(sizeTimer);
    //             }
    //         }, 100);
    //     }
    //     else {

    //         //console.log("friends[randomFriendIndex]", friends[randomFriendIndex]);

    //         var friendImageUri = this.friendSurpass.img
    //         this.friendImg = PIXI.Sprite.from(friendImageUri);
    //         this.friendImg.visible = true;
    //         this.challengerContainer.addChild(this.friendImg);
    //         this.friendImg.anchor.set(0.5);
    //         this.friendImg.position.set(90, 0);

    //         let sizeTimer = setInterval(() => {
    //             if (this.friendImg.width > 5) {
    //                 this.friendImg.width = 48;
    //                 this.friendImg.scale.y = this.friendImg.scale.x;
    //                 clearInterval(sizeTimer);
    //             }
    //         }, 100);
    //     }

    //     let friendMask = new PIXI.Graphics();
    //     friendMask.beginFill(0x000001);
    //     friendMask.drawCircle(0, 0, 22);
    //     friendMask.position.set(90, 0);
    //     friendMask.endFill();

    //     this.friendBg.mask = friendMask;
    //     this.friendImg.mask = friendMask;
    //     this.challengerContainer.addChild(friendMask);

    //     this.finishChallengeCount = friendScore;
    //     console.log("this.finishChallengeCount", this.finishChallengeCount);
    //     // AssetsManager.players
    //     // config.friends

    //     // Surpass challenge
    //     this.missionDetailText.text = LocaleManager.words.surpassFriend;
    //     if (this.missionDetailText.width > this.missionDetailTextLength) {
    //         this.missionDetailText.width = this.missionDetailTextLength;
    //         this.missionDetailText.scale.y = this.missionDetailText.scale.x;
    //     }
    //     this.missionRewardText.text = this.missionRewardCoins;
    // }


    _createContextChallenger() {
        console.log("_createContextChallenger");

        this.position.y = window.innerHeight * this._coefY;
        gsap.fromTo(this.position, { x: -200 }, { x: 0, duration: 0.5 });

        this.missionRewardCoins = 300 + this.currentDifficulty * 100;

        GameManager.EVENT_DISPATCHER.removeEventListener('score', this._onContextReachScore);
        GameManager.EVENT_DISPATCHER.addEventListener('score', this._onContextReachScore);


        if (this.friendBg != null) {
            this.contextChallengerContainer.removeChild(this.friendBg);
        }

        if (this.friendImg != null) {
            this.contextChallengerContainer.removeChild(this.friendImg);
        }

        const friendBgTexture = AssetsManager.texturesPixi.challengerBackground;
        this.friendBg = new PIXI.Sprite(friendBgTexture);
        this.friendBg.visible = true;
        this.contextChallengerContainer.addChild(this.friendBg);
        this.friendBg.anchor.set(0.5);
        this.friendBg.scale.set(0.35);
        this.friendBg.position.set(90, 0);

        this.friendSurpass = this.opponent;

        console.log("friend seleted: ", this.friendSurpass);

        //console.log("friends[randomFriendIndex]", friends[randomFriendIndex]);

        var friendImageUri = this.friendSurpass.imguri;
        this.friendImg = PIXI.Sprite.from(this.realScore ? friendImageUri : AssetsManager.texturesPixi.friendsPicto);
        this.friendImg.visible = true;
        this.contextChallengerContainer.addChild(this.friendImg);
        this.friendImg.anchor.set(0.5);
        this.friendImg.position.set(90, 0);

        let sizeTimer = setInterval(() => {
            if (this.friendImg.width > 5) {
                this.friendImg.width = 48;
                this.friendImg.scale.y = this.friendImg.scale.x;
                clearInterval(sizeTimer);
            }
        }, 100);


        let friendMask = new PIXI.Graphics();
        friendMask.beginFill(0x000001);
        friendMask.drawCircle(0, 0, 22);
        friendMask.position.set(90, 0);
        friendMask.endFill();

        this.friendBg.mask = friendMask;
        this.friendImg.mask = friendMask;
        this.contextChallengerContainer.addChild(friendMask);

        this.missionNameText.text = this.realScore ? this.friendSurpass.name.toUpperCase() : "GOAL";
        this.missionDetailText.text = this.realScore ? "BEAT YOUR\nFRIEND'S SCORE\n" + this.opponent.score : "MAKE THE HIGHEST\nSCORE TO CHALLENGE\nYOUR FRIEND\n" + this.opponent.score;

        this.missionDetailText.width = this.missionDetailTextLength;
        this.missionDetailText.scale.y = this.missionDetailText.scale.x;
        this.missionRewardText.text = this.missionRewardCoins;


    }

    _addCoins(coins) {
        GameManager.pixiManager.rewardEffect.add(
            "coins",
            { x: this.position.x + 50, y: this.position.y },
            GameManager.pixiManager.coin.coinPos,
            () => {
                GameManager.COIN += coins;
            },
            1
        );
    }

    resize(w, h) {
        this.position.y = h * this._coefY;
        this._heightView = h;
    }
}